import { apiFunctionsEnum } from 'constants/api.constants';
import { errorMessages } from 'constants/ui.constants';
import ApiService from './api.service';
import {
	setBusinessPlans,
	setCoinsCouples,
	setError,
	setLoading,
	addCoinsCouples,
	setAddNewCoinsCouple,
	updateBusinessPlanByIndex,
} from 'state/reducers/plans-business-model.reducers';
import { setError as setErrorRequest } from 'state/reducers/pending-requests.reducer';
import { store } from 'state/store';
import { setErrorMessage } from 'utils/index';
import { setSuccessMessage } from 'state/reducers/ui.reducers';

export function getBusinessModelsPlans() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_BUSINESS_MODEL_PLANS, {})
			.then((response) => {
				dispatch(setBusinessPlans(response.data.modelPlans));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				dispatch(setBusinessPlans(null));
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function saveBusinessModelsPlans(data: any, indexInState: number, savingDataError: string) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		const businessPlans = store.getState().businessModel.businessPlans;
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.SAVE_BUSINESS_PLAN, { ...data })
			.then((response) => {
				if (response.data.newModelPlan) {
					dispatch(
						updateBusinessPlanByIndex({ newModelPlan: response.data.newModelPlan, index: indexInState })
					);
				}
				if (response.data.coinsCouples) {
					dispatch(setCoinsCouples(response.data.coinsCouples));
				}
				dispatch(setSuccessMessage('action.success'));
			})
			.catch((error: any) => {
				setErrorMessage(setErrorRequest, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				//dispatch(setError(savingDataError));
				if (!businessPlans) {
					dispatch(setBusinessPlans(null));
				}
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function getAllCoinsCouples() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.GET_COINS_COUPLES, {})
			.then((response) => {
				dispatch(setCoinsCouples(response.data.coinsCouples));
			})
			.catch((error: any) => {
				setErrorMessage(setError, {
					errorNumber: error?.response?.data?.error_number,
					statusCode: error?.response?.status,
				});
				dispatch(setBusinessPlans(null));
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function updateCoinsCouples(data: any, savingDataError: string) {
	const { planId, sourceCurrencyId, targetCurrencyId } = data;
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.UPDATE_COINS_COUPLES, { planId, sourceCurrencyId, targetCurrencyId })
			.then(() => {})
			.catch((error: any) => {
				dispatch(setError(savingDataError));
				dispatch(setBusinessPlans(null));
			})
			.finally(() => {
				dispatch(setLoading(false));
			});
	};
}

export function createCoinsCouples(data: any, savingDataError: string) {
	const { sourceCurrencyId, targetCurrencyId, isActive } = data;
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setError(null));
		await ApiService.getInstance()
			.execute(apiFunctionsEnum.CREATE_COINS_COUPLES, { sourceCurrencyId, targetCurrencyId, isActive })
			.then((response) => {
				dispatch(addCoinsCouples(response.data.newCoinsCouples));
			})
			.catch((error: any) => {
				dispatch(setError(savingDataError));
				dispatch(setBusinessPlans(null));
			})
			.finally(() => {
				dispatch(setAddNewCoinsCouple(false));
				dispatch(setLoading(false));
			});
	};
}
